import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiFormatError } from "@/lib/api";

export function usePortalData(userId, canViewCatalogLeads = false) {
  const [quotes, setQuotes] = useState([]);
  const [leads, setLeads] = useState([]);
  const [pros, setPros] = useState([]);
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState([]);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setErrors([]); setLeads([]);
    const resources = [["quotes", setQuotes], ["pro-applications", setPros], ["messages", setThreads]];
    if (canViewCatalogLeads) resources.push(["leads", setLeads]);
    Promise.all(resources.map(async ([name, update]) => {
      try {
        const { data } = await api.get(`/admin/${name}`, { signal: controller.signal });
        if (!controller.signal.aborted) update(data || []);
      } catch (error) {
        if (controller.signal.aborted) return;
        console.error(`Portal ${name} load failed`, error.response?.status);
        update([]);
        const message = `${name}: ${apiFormatError(error.response?.data?.detail)}`;
        setErrors((previous) => [...previous, message]); toast.error(message);
      }
    })).finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [userId, canViewCatalogLeads]);
  return { quotes, setQuotes, leads, pros, setPros, threads, setThreads, loading, errors };
}